export default {
	methods: {
		$could(permission, resource = null) {
			if (!this.$store.state.authStore.authed) {
				return false;
			}

			if (!resource) {
				let path = permission.split(".");
				permission = path.pop();

				let node = this.$store.state.authStore.authed.permissions;

				for (let i in path) {
					node = node[path[i]];
				}

				return _.has(node, permission);

				// permission = permission.split('.')
				//
				// return _.has(this.$store.state.authStore.authed.permissions, permission[0]) &&
				// 	_.has(this.$store.state.authStore.authed.permissions[permission[0]], permission[1])
			}

			return _.has(resource.actions, permission);
		},

		$can(permission, resource = null) {
			if (!this.$store.state.authStore?.authed) {
				return false;
			}

			if (!this.$could(permission, resource)) {
				return false;
			}

			if (!resource) {
				let path = permission.split(".");
				permission = path.pop();

				let node = this.$store.state.authStore.authed.permissions;

				for (let i in path) {
					node = node[path[i]];
				}

				return _.get(node, permission);
			}

			return resource.actions[permission];
		},
	},
};
